export const PlayerEvents = {
  BACK: "back",
  LONG_BACK: "long_back",
  ERROR: "error",
  CONNECT: "connect",
  DISCONNECT: "disconnect",
  IS_PLAYING: "is_playing",
  GAMEPAD_CONNECT: "gamepad_connect",
  GAMEPAD_DISCONNECT: "gamepad_disconnect",
  GAMEPAD_EVENT: "gamepad_event",
  METRIC: "metric",
  PAUSED: "paused",
  SUSPENDED: "suspended",
  RECONNNECTING: "reconnecting",
};

class EventEmitter {
  events;
  constructor() {
    this.events = {};
  }

  /**
   * Event listener
   * @param label label of event to listen
   * @param callback callback to execute
   */
  on(event, listener) {
    if (typeof this.events[event] !== "object") {
      this.events[event] = [];
    }

    this.events[event].push(listener);
    return () => this.off(event, listener);
  }
  off(event, listener) {
    if (typeof this.events[event] === "object") {
      const idx = this.events[event].indexOf(listener);

      if (idx > -1) {
        this.events[event].splice(idx, 1);
      }
    }
  }
  offAll() {
    this.events = {};
  }

  emit(event, ...args) {
    if (typeof this.events[event] === "object") {
      this.events[event].forEach((listener) => {
        try {
          listener.apply(this, args);
        } catch (e) {
          console.error(`error on ${event} emit`, e);
        }
      });
    }
  }
  once(event, listener) {
    const remove = this.on(event, (...args) => {
      remove();
      listener.apply(this, args);
    });
  }
}

export let eventEmitter = new EventEmitter();
